import styled from 'styled-components';
import colors from '../../../helpers/colors';
import fonts from '../../../helpers/fonts';
import mediaQuery from '../../../helpers/mediaQuery';
import spacing from '../../../helpers/spacing';
import { GridItem } from '../../Grid';
import Icon from '../../Icon';
import Image from '../../Image';
import Link from '../../Link';
import RichText from '../../RichText';

export const SectionGridItem = styled(GridItem)<{ isIconSection?: boolean }>`
  padding: 0;
  padding-bottom: ${spacing(5)};
  display: flex;
  flex-flow: ${({ isIconSection }) => (isIconSection ? 'row' : 'column')};
  align-items: ${({ isIconSection }) => (isIconSection ? 'end' : 'start')};
  ${mediaQuery.tabletPortrait`
    margin-top: 0;
    flex-flow: column;
    align-items: start;
  `};
`;

export const SectionHeading = styled.h2<{ isIconSection?: boolean }>`
  ${fonts.headingSmall}
  padding: 0;
  margin: 0 0 ${spacing(3)};
  margin-right: ${({ isIconSection }) => (isIconSection ? '30px' : '0')};
`;

export const UnorderedList = styled.ul<{ isIconSection?: boolean }>`
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: flex;
  & > li * {
    ${fonts.paragraphSmall}
  }
  flex-flow: ${({ isIconSection }) => (isIconSection ? 'row' : 'column')};
  flex-wrap: ${({ isIconSection }) => (isIconSection ? 'wrap' : 'nowrap')};
  ${mediaQuery.tabletPortrait`
    flex-flow: column;
    flex-wrap: nowrap;
  `}
`;

export const LinkItem = styled.li`
  margin-bottom: ${spacing(2)};
  padding-right: ${spacing(2)};
  display: flex;

  ${mediaQuery.tabletPortrait`
    margin-bottom: ${spacing(2)};
    padding-right: 0;
  `};
`;

export const StyledLink = styled(Link)`
  ${fonts.paragraph};
  display: inline-flex;
  color: ${colors.core01};
  align-items: baseline;
`;

export const LinkItemIcon = styled(Icon)`
  width: ${spacing(2)};
  margin: 0 ${spacing(1)};
  padding: 0;
`;

export const SectionBody = styled(RichText)`
  ${fonts.paragraphSmall}
  color: ${colors.neutral01};
  a {
    color: ${colors.core01};
    text-decoration: none;
  }
`;

export const LinkText = styled.p`
  ${fonts.paragraph};
  margin: 0;
  padding: 0;
  display: none;
  align-self: center;

  ${mediaQuery.tabletPortrait`
    display: inline-block;
  `};
`;

export const SocialMediaLogo = styled(Image)`
  height: ${spacing(6)};
  width: auto;
  border-radius: 1px;
  margin: auto 0;

  ${mediaQuery.tabletPortrait`
    height: ${spacing(3)};
    margin: 0 ${spacing(1)} 0 0;
  `};
`;
